export async function startAiTemplateGeneration (formData) {
    return await fetch(`${process.env.SITEBUILDER_API}/api/builderall-home/generate-template`, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }), 
        body: JSON.stringify(formData)
    })
    .then(r => r.json())
    .then(response => {
        return response;
    })
    .catch(e => {
        console.error('Error generating site: ',e);
    })
}

export async function getAiTemplateGenerationStatus(generationId) {
    return await fetch(`${process.env.SITEBUILDER_API}/api/builderall-home/generate-status/${generationId}`)
    .then(r => r.json())
    .then(response => {
        return response;
    })
    .catch(e => {
        console.error('Error generating site: ',e);
    })
}